import User from '@/api/user.api.js';
import { SETTING_TYPES } from '@/constants/setting.js';
import { THEME_LIST, DEFAULT_THEME_INDEX } from "@/constants/setting.js";
import _ from 'lodash';

/*eslint-disable */
export const getTheme = ({ commit }) => {
  return User.getSetting(SETTING_TYPES.THEME)
    .then(response => {
      if (response && response.success) {
        commit('SET_SETTING', {'theme': getThemeName(response.data) });
      }
    })
    .catch(function (error) {
      console.log(error)
    });
}

export const updateTheme = ({ commit }, data) => {
  return User.updateSetting(SETTING_TYPES.THEME, { settings: data })
    .then(response => {
      if (response && response.success) {
        commit('SET_SETTING', {'theme': getThemeName(response.data) });
      }
    })
    .catch(function (error) {
      console.log(error)
    });
}

function getThemeName (code) {
  let theme = _.find(THEME_LIST, { code });
  if (theme) {
    return theme;
  }
  return THEME_LIST[DEFAULT_THEME_INDEX];
}

/*eslint-enable */
